(() => {
  // Preview image/title/text swap on mega-link hover (panels 1 & 5)
  document.querySelectorAll('.bt-mega-panel').forEach((panel) => {
    const previewLink = panel.querySelector('[data-preview-link]');
    const img         = panel.querySelector('[data-preview-img]');
    const title       = panel.querySelector('[data-preview-title]');
    const text        = panel.querySelector('[data-preview-text]');
    const links       = Array.from(panel.querySelectorAll('.bt-mega-link'));

    if (!img && !title) return;

    const activate = (link) => {
      links.forEach((item) => item.classList.toggle('is-active', item === link));
      if (!link) return;
      if (previewLink && link.href) previewLink.href = link.href;
      if (img && link.dataset.img)  img.src = link.dataset.img;
      if (title) title.textContent = link.dataset.title || link.textContent.trim();
      if (text)  text.textContent  = link.dataset.text  || '';
    };

    if (links[0]) activate(links[0]);
    links.forEach((link) => {
      link.addEventListener('mouseenter', () => activate(link));
      link.addEventListener('focus',      () => activate(link));
    });
  });

  // Guide flyout swap (panel 3 - Install Guide)
  document.querySelectorAll('.bt-guide-panel').forEach((panel) => {
    const items      = Array.from(panel.querySelectorAll('.bt-guide-item'));
    const previewImg = panel.querySelector('.bt-guide-preview-img');
    const previewTxt = panel.querySelector('.bt-guide-preview-text');
    const flyouts    = Array.from(panel.querySelectorAll('.bt-guide-flyout'));

    const setPreview = (img, text, pos) => {
      if (previewImg && img) previewImg.src = img;
      if (previewImg) previewImg.style.objectPosition = pos || 'center center';
      if (previewTxt) previewTxt.textContent = text || '';
    };

    const setActive = (item) => {
      items.forEach((e) => e.classList.toggle('is-active', e === item));
      flyouts.forEach((f) => f.classList.toggle('is-active', f.dataset.flyoutId === item.dataset.flyout));
      const activeFlyout = panel.querySelector('.bt-guide-flyout[data-flyout-id="' + item.dataset.flyout + '"]');
      const firstLink = activeFlyout ? activeFlyout.querySelector('a[data-img]') : null;
      const previewLink = firstLink || item;
      setPreview(
        (firstLink && firstLink.dataset.img) || item.dataset.img,
        firstLink && firstLink.dataset.text,
        previewLink.dataset.imgPosition
      );
    };

    items.forEach((item) => {
      const trigger = item.querySelector('.bt-guide-main');
      if (!trigger) return;
      trigger.addEventListener('mouseenter', () => setActive(item));
      trigger.addEventListener('focus',      () => setActive(item));
    });

    panel.querySelectorAll('.bt-flyout-links a').forEach((link) => {
      link.addEventListener('mouseenter', () => setPreview(link.dataset.img, link.dataset.text, link.dataset.imgPosition));
      link.addEventListener('focus',      () => setPreview(link.dataset.img, link.dataset.text, link.dataset.imgPosition));
    });

    panel.addEventListener('mouseleave', () => { if (items[0]) setActive(items[0]); });
    if (items[0]) setActive(items[0]);
  });

  // Keep District theme's CartCount in sync on desktop
  document.addEventListener('cart:updated', () => {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const el = document.getElementById('CartCount');
      if (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      }
    });
  });

  // "Add to Cart" → "Added to Cart" button flip
  // The theme adds .added class on submit, removes it after 500ms reset.
  // We intercept that removal and extend the "Added to Cart" state to 2s.
  const atcObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'class') return;
      const btn = mutation.target;
      if (!btn.matches('[data-AddToCart]')) return;
      const hadAdded = mutation.oldValue && mutation.oldValue.includes('added');
      const hasAdded = btn.classList.contains('added');
      if (hadAdded && !hasAdded) {
        // Theme just reset after 500ms — show "Added to Cart" for 2s instead
        const textSpan = btn.querySelector('[data-AddToCartText]') || btn.closest('form') && btn.closest('form').querySelector('[data-AddToCartText]');
        const originalHTML = textSpan ? textSpan.innerHTML : btn.innerHTML;
        if (textSpan) textSpan.innerHTML = 'Added to Cart';
        else btn.innerHTML = 'Added to Cart';
        btn.disabled = true;
        clearTimeout(btn._atcTimer);
        btn._atcTimer = setTimeout(() => {
          if (textSpan) textSpan.innerHTML = originalHTML;
          else btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 2000);
      }
    });
  });
  document.querySelectorAll('[data-AddToCart]').forEach((btn) => {
    atcObserver.observe(btn, { attributes: true, attributeOldValue: true });
  });
  // Also catch buttons added after page load (quick-add, etc.)
  new MutationObserver(() => {
    document.querySelectorAll('[data-AddToCart]').forEach((btn) => {
      if (!btn._atcObserved) {
        btn._atcObserved = true;
        atcObserver.observe(btn, { attributes: true, attributeOldValue: true });
      }
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Theme editor: sticky-lock panels open on hover so the customizer
  // sidebar can be used without the menu closing.
  if (document.documentElement.classList.contains('shopify-design-mode')) {
    const navItems = Array.from(document.querySelectorAll('.bt-nav-item'));

    // Hovering a nav item locks that panel open
    navItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        navItems.forEach((i) => i.classList.remove('is-open'));
        item.classList.add('is-open');
      });
    });

    // Clicking the nav label toggles it closed (so user can dismiss)
    document.querySelectorAll('.bt-nav-label').forEach((label) => {
      label.addEventListener('click', (e) => {
        e.preventDefault();
        const item = label.closest('.bt-nav-item');
        if (item) item.classList.toggle('is-open');
      });
    });
  }
})();
